import { Injectable } from "@angular/core";
import { DashboardService } from "../dashboard.service";
import { BehaviorSubject } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { AlertService } from "../../alert.service";
import { StorageService } from "../../storage.service";
import { ReportTypes } from "../../../reports/models/reports";
import { TopCancellationReasonsResponse } from "../../../_models/dashboard";

@Injectable({
  providedIn: "root",
})
export class ReturnsReasonsService extends DashboardService {
  route = "returns_dashboard/top_cancellation_reasons";
  protected reportType = ReportTypes.RETURN_RETENTION;
  protected data: BehaviorSubject<TopCancellationReasonsResponse> = new BehaviorSubject<TopCancellationReasonsResponse>(undefined);

  constructor(
    protected http: HttpClient,
    protected alertService: AlertService,
    protected storageService: StorageService
  ) {
    super(http, alertService, storageService);
  }

}
